import { PersonalDetails, getPersonalDetailsEndpoint } from 'cpie-common';
import { getSimpleDataFetchSlice } from '@cp-shared-15/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';

const { reducer, fetchData } = getSimpleDataFetchSlice<PersonalDetails, DefaultBusinessMarketApiErrorCode>({
    dataName: 'myProfile',
    fetchCallback() {
        return CpDataApi.get(getPersonalDetailsEndpoint()).then(response => response.data);
    },
});

export default reducer;
export const fetchMyProfile = fetchData;
